//imports
import { all } from 'redux-saga/effects';

//Views
import editBrandSagas from 'Modules/brands/views/.components/editBrand/redux/saga';
import brandOverviewSagas from 'Modules/brands/views/overview/redux/saga';
import createEditMessageTemplateSagas from 'Modules/brands/views/.components/createEditMessageTemplate/redux/saga';
import deleteMessageTemplateSagas from 'Modules/brands/views/.components/deleteMessageTemplate/redux/saga';
import deleteBrandSagas from 'Modules/brands/views/.components/deleteBrand/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        editBrandSagas(),
        brandOverviewSagas(),
        createEditMessageTemplateSagas(),
        deleteMessageTemplateSagas(),
        deleteBrandSagas(),
    ]);
}